/*
 * @Description: 名单库添加
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-10 13:57:25
 */
import { projectPersonnelManagement } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '名单库添加',
  // list: invoice.invoiceOpenList,
  list: projectPersonnelManagement.panelLibraryAddsAList,

  requestNow: true,
  search: ['fullName', 'phone', 'personLabel'],
  fields: [
    'selection',
    'index',
    'fullName',
    'phone',
    'otherPersonLabel',
    'importPersonLabel'
  ]
});

let individualPart = example.createPart({
  name: '名单库添加',
  // list: invoice.invoiceOpenList,
  list: projectPersonnelManagement.panelLibraryAddsAList,

  requestNow: true,
  search: [
    {
      width: 180,
      label: '经营者',
      tip: '请输入关键字',
      key: 'fullName',
      id: 'fullName',
      slot: 'input'
    },
    'phone',
    'personLabel'
  ],
  fields: [
    'selection',
    'index',
    {
      label: '经营者',
      prop: 'NAME'
    },
    'enterpriseName',
    'phone',
    'otherPersonLabel',
    'importPersonLabel'
  ]
});

export default [
  [{ name: '名单库添加', childMenu: [part] }],
  [{ name: '名单库添加', childMenu: [individualPart] }]
];
